import useSetting from '../../../Setting/Api/useSetting';
import { SettingSource } from '../../../Setting/SettingStore';

export default function useFavoriteDashboardIds()
{
    return useSetting<string[]>(SettingSource.User, 'Dashboard.Favorites');
}
